import { apiClient } from './api';
import { MultiFashionRequest, MultiFashionResponse } from '../models/fashion';

export class FashionService {
  static async generateFashionDesign(request: MultiFashionRequest): Promise<MultiFashionResponse> {
    const response = await apiClient.post('/api/multi-agent/fashion/start', request);
    return response.data;
  }
}

export default FashionService;